import { render, staticRenderFns } from "./ReportSantamClaimsLadumaAward.vue?vue&type=template&id=7b49db58&"
import script from "./ReportSantamClaimsLadumaAward.vue?vue&type=script&lang=js&"
export * from "./ReportSantamClaimsLadumaAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports